import { SxProps, Theme } from '@mui/material';

export const productPLPDiscountSX: SxProps<Theme> = () => ({
	color: '#AB2326',
	fontSize: 'var(--font-size-sm)',
	fontWeight: '600',
	marginRight: '8px',
	textDecoration: 'none',
});

export const productPLPPriceSX = (hasDiscount: boolean): SxProps<Theme> => ({
	color: '#2C2C2C',
	fontSize: 'var(--font-size-sm)',
	fontWeight: '600',
	textDecoration: hasDiscount ? 'line-through' : 'none',
});

export const productPLPTitleSX = (isFavorite: boolean): SxProps<Theme> => ({
	color: '#2C2C2C',
	fontSize: { xs: 'var(--font-size-default)', sm: 'var(--font-size-body)' },
	fontWeight: '600',
	textDecoration: 'none',
	overflow: 'hidden',
	display: '-webkit-box',
	WebkitLineClamp: isFavorite ? 2 : 2,
	WebkitBoxOrient: 'vertical',
	textOverflow: 'ellipsis',
	maxWidth: isFavorite ? { xs: '150px', sm: undefined } : undefined,
	mb: '4px',
});

export const productPLPSubtitleSX: SxProps<Theme> = () => ({
	color: '#2C2C2C',
	fontSize: 'var(--font-size-default)',
	fontWeight: '500',
	textDecoration: 'none',
});

export const productPLPContentSX = (isFavorite: boolean): SxProps<Theme> => ({
	width: isFavorite ? { xs: 'auto', sm: '200px' } : 'auto',
	height: isFavorite ? '188px' : '124px',
	p: '0px 15px 15px 15px',
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'space-between',
});

export const productPLPImageSX = (isFavorite: boolean): SxProps<Theme> => ({
	height: 'auto',
	width: { xs: '100%', md: isFavorite ? '200px' : '100%' },
	objectFit: { xs: 'contain', lg: 'contain' },
	backgroundColor: '#cbcbcb',
});

export const productPLPFavoriteButtonSX: SxProps<Theme> = {
	position: 'absolute',
	top: '8px',
	right: '8px',
	zIndex: 1,
	backgroundColor: 'white',
	boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
};

export const productPLPRibbonSX: SxProps<Theme> = {
	p: '2px 6px',
	color: 'white',
	fontSize: 'var(--font-size-small)',
	fontWeight: 'bold',
	textDecoration: 'none',
	textTransform: 'uppercase',
	backgroundColor: '#AB2326',
	borderRadius: '11px',
	width: 'auto',
	textAlign: 'center',
};

export const productPLPRibbonFrameSX: SxProps<Theme> = {
	position: 'absolute',
	top: '8px',
	left: '12px',
};

export const productPLPSizeSX: SxProps<Theme> = {
	color: '#2C2C2C',
	fontSize: 'var(--font-size-default)',
	fontWeight: 'normal',
	mb: '4px',
};

export const productPLPAddToCartButtonSX: SxProps<Theme> = { marginTop: '10px' };
